import React from 'react';

import { t } from '~/helpers';

export default function ComponentDelete() {
  return (
    <div style={{ textAlign: 'center' }}>
      <p>{t('s.geral.esta_acao_nao_podera_mais_ser_desfeita_pelo_sistema')}</p>
    </div>
  );
}
